<template>
  <h3>VIZBI Showcases</h3>
  <p>
    The VIZBI Showcases are public outreach events exploring how visualization, animation, and
    art can bring the life sciences to wider audiences. Launched in 2013, they grew from the
    broader <router-link to="/About">VIZBI initiative</router-link>, extending its focus on
    scientific visualization and visual storytelling beyond the research community.
  </p>
  <p>
    Each Showcase brings together scientists, biomedical animators, data visualization experts,
    filmmakers, and visual artists for an evening of compelling visual science communication and
    conversation with the public.
  </p>
  <p>
    VIZBI Showcase events are usually held alongside the annual
    <router-link to="/">VIZBI Workshop</router-link> and
    <router-link to="/Masterclass">Data Visualization Masterclass</router-link>. Additional
    Showcase events have been organised in collaboration with
    <a href="https://www.vividsydney.com/info/about-vivid-sydney" target="_blank" rel="noopener">
      Vivid Sydney</a>
    or to feature new animations or installations arising from the
    <router-link to="/Plus">VIZBI Plus project</router-link>, and its continuation, the
    <router-link to="/Collective">VIZBI Collective</router-link>.
  </p>
  <section v-for="showcase in showcases" :key="showcase.link">
    <h4>
      <router-link :to="showcase.link">{{ headingFor(showcase) }}</router-link>
    </h4>
    <router-link v-if="showcase.image" :to="showcase.link">
      <img :src="showcase.image" :alt="`VIZBI Showcase ${showcase.year} hero image`" />
    </router-link>
  </section>
</template>

<script setup>
import showcases, {headingFor} from "@/assets/showcases";
</script>

<style scoped>
h3 {
  display: inline;
}
section {
  margin-top: 2.5rem;
}
h4 {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}
img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}
</style>
